import { render, staticRenderFns } from "./SponsorAnalytics.vue?vue&type=template&id=bc436af0"
import script from "./SponsorAnalytics.vue?vue&type=script&lang=js"
export * from "./SponsorAnalytics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports